import {ScrollViewProps} from 'react-native';

/**
 * DIS-1555: opts a horizontal carousel into an always-visible scrollbar on web.
 *
 * `showsHorizontalScrollIndicator` on its own is not enough. macOS renders an
 * overlay scrollbar that auto-hides when idle, so a desktop user on a traditional
 * mouse — no trackpad swipe gesture — sees no affordance and cannot reach content
 * past the visible edge. The attribute this returns is matched by the
 * `[data-visible-scrollbar]` rules in `web/index.html`, which style
 * `::-webkit-scrollbar` and thereby opt the element out of overlay mode.
 *
 * Pass the same condition used for `showsHorizontalScrollIndicator` so the two can
 * never disagree. Inert on native, where `dataSet` is ignored.
 */
export const visibleScrollbarProps = (enabled: boolean): Pick<ScrollViewProps, 'dataSet'> =>
  enabled ? {dataSet: {visibleScrollbar: 'true'}} : {};
